const isProduction = process.env.NODE_ENV === 'production'

if (isProduction) {
  module.exports = require('./native-jsbridge')
} else {
  module.exports = require('./mock-jsbridge')
}
// module.exports = require('./native-jsbridge')
